export const stage: 'ide' | 'dev' | 'test' | 'prod' = import.meta.env.VITE_STAGE;